<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
  <ng-container [ngSwitch]="data.type">
    <ng-container *ngSwitchCase="'success'">
      <mat-icon class="color-teal u-display-block" fxFlex="24px">
        check
      </mat-icon>
    </ng-container>
    <ng-container *ngSwitchCase="'error'">
      <mat-icon class="color-orange-900 u-display-block" fxFlex="24px">
        close
      </mat-icon>
    </ng-container>
  </ng-container>
  <div fxFlex="calc(100% - 24px)">
    <span i18n="@@customToast.message"
      >{data.message, select, other {{{ data.message }}} }</span
    >
  </div>
</div>
